import { getErrorPayload } from '@application/common/helpers/api-helper';
import InvoiceApi from '@infrastructure/invoice-api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { addSuccessNotification } from '../common/notificationSlice';
import { translate } from '@application/common/helpers/translate';
export const getAllInvoices = createAsyncThunk('invoices/GetInvoicesByMonthAndYear', async (reqeust, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await InvoiceApi.getAllInvoices(reqeust);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const getInvoicesByStatusAsync = createAsyncThunk('invoices/getInvoicesByStatusAsync', async (invoiceStatus, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await InvoiceApi.getInvoicesByStatus(invoiceStatus);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const AddUpdateInvoice = createAsyncThunk('invoices/AddUpdateInvoice', async (reqeust, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await InvoiceApi.AddUpdateInvoice(reqeust);
        dispatch(addSuccessNotification(translate('invoice.invoiceAddedSuccessfullyNotification')));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const UpdateInvoiceStatusAsync = createAsyncThunk('invoices/updateInvoiceStatus', async (request, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await InvoiceApi.UpdateInvoiceStatus(request);
        dispatch(addSuccessNotification(translate('invoice.invoiceUpdatedSuccessfullyNotification')));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const getByInvoiceId = createAsyncThunk('invoices/GetInvoiceById', async (reqeust, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await InvoiceApi.getByInvoiceId(reqeust);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const moveBasicInvoiceToNextStageAsync = createAsyncThunk('invoices/moveBasicInvoiceToNextStage', async (invoiceId, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await InvoiceApi.moveBasicInvoiceToNextStage(invoiceId);
        dispatch(addSuccessNotification(translate('invoice.invoiceUpdatedSuccessfullyNotification')));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
